export const CourseEndpoints = {
  CourseList: '/v3/course',
  CourseInfo: (course_id: string) => `/v3/course/${course_id}`,
  ActiveCourses: `/v3/user/activeCourse`,
  LastActiveCourse: '/v3/user/last-active-course',
  CourseSections: (courseId: string) => `/v3/course/section/${courseId}`,
  course_register: '/v3/course/register',
  RemoveEnrollment: '/v3/user/delete/course',
  VideoAnswer: '/v3/course/video/answer',
  Roadmap: (courseId: string) => `/v3/course/roadmap?courseId=${courseId}`,
  PreRegister: '/v3/course/preRegister',
  Activity: '/v3/course/activity',
  Certificate: (courseId: string) => `/v3/course/${courseId}/certificate`,
  PublicCertificate: (payload: { courseId: string; userId: string }) =>
    `/v3/course/${payload.courseId}/certificate/${payload.userId}`
} as const
